import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/core/course.service';
import { Course } from 'src/app/models/course.model';
import { CreateCourseComponent } from './create-course/create-course.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ControlsModule } from 'src/app/controls/controls.module';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-courses-view',
  templateUrl: './courses-view.component.html',
  styleUrls: ['./courses-view.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    ControlsModule,
    SharedModule,
    CreateCourseComponent
  ]
})
export class CoursesViewComponent {

  courses?: Course[];
  createCourse: boolean = false;
  deviceType?: 'mobile' | 'tablet' | 'desktop';

  constructor(
    private courseService: CourseService,
    private router: Router
  ) {}

  ngOnInit() {
    this.courseService.fetchCourses();
    this.courseService.getCourses().subscribe(courses => this.courses = courses);
  }

  addCourse() {
    this.createCourse = true;
  }

  openCourse(course: Course) {
    this.router.navigate([`/courses/${course.id}`]);
  }

  courseCreated() {
    this.createCourse = false;
    this.courseService.fetchCourses();
  }
}
